import http from "@/utils/request"

const dictList = async (url) => {
    try {
        const res = await http.get('/sys/dictValue/getValueByType?type=' + url)
        return  res.data
    } catch (error) {
        return error
    }
}
export default dictList